export const fonts = {
    abel: `"Abel", sans-serif`,
    lato: `"Lato", sans-serif`,
    gothamRounded: `"Gotham Rounded", sans-serif`,
    gothamRoundedBook: `"Gotham Rounded Book", sans-serif`,
    playfairDisplay: `"Playfair Display", serif`,
    roboto: `"Roboto", sans-serif`,
    ibmPlexSans: `"IBM Plex Sans", sans-serif`,
};
